var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "c-gauge-style" },
    [
      _c(
        "el-collapse",
        [
          _c(
            "el-collapse-item",
            { attrs: { title: "仪表盘样式" } },
            [
              _c("el-form-item", [
                _c(
                  "div",
                  { staticClass: "chart-form-item-warp" },
                  [
                    _c("span", { staticClass: "jz-chart-title-label" }, [
                      _vm._v("主题色"),
                    ]),
                    _vm._v(" "),
                    _c("el-color-picker", {
                      model: {
                        value:
                          _vm.selectItem.styleConfig.commongConfig
                            .gaugeThemeColor,
                        callback: function ($$v) {
                          _vm.$set(
                            _vm.selectItem.styleConfig.commongConfig,
                            "gaugeThemeColor",
                            $$v
                          )
                        },
                        expression:
                          "selectItem.styleConfig.commongConfig.gaugeThemeColor",
                      },
                    }),
                  ],
                  1
                ),
              ]),
              _vm._v(" "),
              _c("el-form-item", [
                _c(
                  "div",
                  {
                    staticClass: "chart-form-item-warp",
                    staticStyle: { "margin-top": "0" },
                  },
                  [
                    _c("span", { staticClass: "jz-chart-title-label" }, [
                      _vm._v("透明度"),
                    ]),
                    _vm._v(" "),
                    _c("el-slider", {
                      staticStyle: { flex: "1" },
                      model: {
                        value:
                          _vm.selectItem.styleConfig.commongConfig
                            .gaugeThemeOpacity,
                        callback: function ($$v) {
                          _vm.$set(
                            _vm.selectItem.styleConfig.commongConfig,
                            "gaugeThemeOpacity",
                            $$v
                          )
                        },
                        expression:
                          "selectItem.styleConfig.commongConfig.gaugeThemeOpacity",
                      },
                    }),
                  ],
                  1
                ),
              ]),
              _vm._v(" "),
              _c("el-form-item", [
                _c(
                  "div",
                  {
                    staticClass: "chart-form-item-warp",
                    staticStyle: { "margin-top": "0" },
                  },
                  [
                    _c("span", { staticClass: "jz-chart-title-label" }, [
                      _vm._v("半径占比"),
                    ]),
                    _vm._v(" "),
                    _c("el-slider", {
                      staticStyle: { flex: "1" },
                      model: {
                        value:
                          _vm.selectItem.styleConfig.commongConfig
                            .gaugeRadiusRatio,
                        callback: function ($$v) {
                          _vm.$set(
                            _vm.selectItem.styleConfig.commongConfig,
                            "gaugeRadiusRatio",
                            $$v
                          )
                        },
                        expression:
                          "selectItem.styleConfig.commongConfig.gaugeRadiusRatio",
                      },
                    }),
                  ],
                  1
                ),
              ]),
              _vm._v(" "),
              _c(
                "el-form-item",
                [
                  _c("style-sub-item", { attrs: { title: "内部刻度线" } }, [
                    _c(
                      "div",
                      {
                        staticClass: "chart-form-item-warp",
                        staticStyle: { "margin-top": "0" },
                      },
                      [
                        _c("span", { staticClass: "jz-chart-title-label" }, [
                          _vm._v("是否开启"),
                        ]),
                        _vm._v(" "),
                        _c("el-switch", {
                          model: {
                            value:
                              _vm.selectItem.styleConfig.commongConfig
                                .gaugeInnerTickEnable,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.selectItem.styleConfig.commongConfig,
                                "gaugeInnerTickEnable",
                                $$v
                              )
                            },
                            expression:
                              "selectItem.styleConfig.commongConfig.gaugeInnerTickEnable",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "chart-form-item-warp",
                        staticStyle: { "margin-top": "12px" },
                      },
                      [
                        _c("span", { staticClass: "jz-chart-title-label" }, [
                          _vm._v("刻度线形式"),
                        ]),
                        _vm._v(" "),
                        _c(
                          "el-radio-group",
                          {
                            model: {
                              value:
                                _vm.selectItem.styleConfig.commongConfig
                                  .gaugeInnerTick,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.selectItem.styleConfig.commongConfig,
                                  "gaugeInnerTick",
                                  $$v
                                )
                              },
                              expression:
                                "selectItem.styleConfig.commongConfig.gaugeInnerTick",
                            },
                          },
                          [
                            _c("el-radio", { attrs: { label: 1 } }, [
                              _vm._v("显示原值"),
                            ]),
                            _vm._v(" "),
                            _c("el-radio", { attrs: { label: 0 } }, [
                              _vm._v("显示百分比"),
                            ]),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-collapse-item",
            { attrs: { title: "数据标签" } },
            [
              _c(
                "style-sub-item",
                {
                  staticClass: "c-bi-dashboard-text-style",
                  staticStyle: { "margin-top": "12px", padding: "12px" },
                  attrs: { title: "主标签" },
                },
                [
                  _c(
                    "div",
                    { staticClass: "chart-form-item-warp" },
                    [
                      _c("span", { staticClass: "jz-chart-title-label" }, [
                        _vm._v("\n            标签样式\n          "),
                      ]),
                      _vm._v(" "),
                      _c(
                        "el-radio-group",
                        {
                          model: {
                            value:
                              _vm.selectItem.styleConfig.commongConfig
                                .gaugeLabelStyle,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.selectItem.styleConfig.commongConfig,
                                "gaugeLabelStyle",
                                $$v
                              )
                            },
                            expression:
                              "selectItem.styleConfig.commongConfig.gaugeLabelStyle",
                          },
                        },
                        [
                          _c("el-radio", { attrs: { label: 1 } }, [
                            _vm._v("显示指标值"),
                          ]),
                          _vm._v(" "),
                          _c("el-radio", { attrs: { label: 0 } }, [
                            _vm._v("显示百分比"),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { staticStyle: { "margin-bottom": "12px" } },
                    [
                      _c("div", [_vm._v("名称")]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "chart-form-item-warp" },
                        [
                          _c("span", { staticClass: "jz-chart-title-label" }, [
                            _vm._v("\n              字体颜色\n            "),
                          ]),
                          _vm._v(" "),
                          _c("el-color-picker", {
                            model: {
                              value:
                                _vm.selectItem.styleConfig.commongConfig
                                  .labelConfig.textConfig.labelColor,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.selectItem.styleConfig.commongConfig
                                    .labelConfig.textConfig,
                                  "labelColor",
                                  $$v
                                )
                              },
                              expression:
                                "selectItem.styleConfig.commongConfig.labelConfig.textConfig.labelColor",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "chart-form-item-warp" },
                        [
                          _c("span", { staticClass: "jz-chart-title-label" }, [
                            _vm._v("\n              字体大小\n            "),
                          ]),
                          _vm._v(" "),
                          _c("el-input-number", {
                            attrs: {
                              min: 12,
                              max: 20,
                              step: 1,
                              "controls-position": "right",
                            },
                            model: {
                              value:
                                _vm.selectItem.styleConfig.commongConfig
                                  .labelConfig.textConfig.labelFontSize,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.selectItem.styleConfig.commongConfig
                                    .labelConfig.textConfig,
                                  "labelFontSize",
                                  $$v
                                )
                              },
                              expression:
                                "selectItem.styleConfig.commongConfig.labelConfig.textConfig.labelFontSize",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "chart-form-item-warp" },
                        [
                          _c("span", { staticClass: "jz-chart-title-label" }, [
                            _vm._v("\n              加粗\n            "),
                          ]),
                          _vm._v(" "),
                          _c("el-switch", {
                            model: {
                              value:
                                _vm.selectItem.styleConfig.commongConfig
                                  .labelConfig.textConfig.labelIsBold,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.selectItem.styleConfig.commongConfig
                                    .labelConfig.textConfig,
                                  "labelIsBold",
                                  $$v
                                )
                              },
                              expression:
                                "selectItem.styleConfig.commongConfig.labelConfig.textConfig.labelIsBold",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "chart-form-item-warp" },
                        [
                          _c("span", { staticClass: "jz-chart-title-label" }, [
                            _vm._v("\n              斜体\n            "),
                          ]),
                          _vm._v(" "),
                          _c("el-switch", {
                            model: {
                              value:
                                _vm.selectItem.styleConfig.commongConfig
                                  .labelConfig.textConfig.labelIsItalic,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.selectItem.styleConfig.commongConfig
                                    .labelConfig.textConfig,
                                  "labelIsItalic",
                                  $$v
                                )
                              },
                              expression:
                                "selectItem.styleConfig.commongConfig.labelConfig.textConfig.labelIsItalic",
                            },
                          }),
                        ],
                        1
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { staticStyle: { "margin-bottom": "12px" } },
                    [
                      _c("div", [_vm._v("数值")]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "chart-form-item-warp" },
                        [
                          _c("span", { staticClass: "jz-chart-title-label" }, [
                            _vm._v("\n              字体颜色\n            "),
                          ]),
                          _vm._v(" "),
                          _c("el-color-picker", {
                            model: {
                              value:
                                _vm.selectItem.styleConfig.commongConfig
                                  .labelConfig.textConfig.valueColor,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.selectItem.styleConfig.commongConfig
                                    .labelConfig.textConfig,
                                  "valueColor",
                                  $$v
                                )
                              },
                              expression:
                                "selectItem.styleConfig.commongConfig.labelConfig.textConfig.valueColor",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "chart-form-item-warp" },
                        [
                          _c("span", { staticClass: "jz-chart-title-label" }, [
                            _vm._v("\n              字体大小\n            "),
                          ]),
                          _vm._v(" "),
                          _c("el-input-number", {
                            attrs: {
                              min: 12,
                              max: 20,
                              step: 1,
                              "controls-position": "right",
                            },
                            model: {
                              value:
                                _vm.selectItem.styleConfig.commongConfig
                                  .labelConfig.textConfig.valueFontSize,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.selectItem.styleConfig.commongConfig
                                    .labelConfig.textConfig,
                                  "valueFontSize",
                                  $$v
                                )
                              },
                              expression:
                                "selectItem.styleConfig.commongConfig.labelConfig.textConfig.valueFontSize",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "chart-form-item-warp" },
                        [
                          _c("span", { staticClass: "jz-chart-title-label" }, [
                            _vm._v("\n              加粗\n            "),
                          ]),
                          _vm._v(" "),
                          _c("el-switch", {
                            model: {
                              value:
                                _vm.selectItem.styleConfig.commongConfig
                                  .labelConfig.textConfig.valueIsBold,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.selectItem.styleConfig.commongConfig
                                    .labelConfig.textConfig,
                                  "valueIsBold",
                                  $$v
                                )
                              },
                              expression:
                                "selectItem.styleConfig.commongConfig.labelConfig.textConfig.valueIsBold",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "chart-form-item-warp" },
                        [
                          _c("span", { staticClass: "jz-chart-title-label" }, [
                            _vm._v("\n              斜体\n            "),
                          ]),
                          _vm._v(" "),
                          _c("el-switch", {
                            model: {
                              value:
                                _vm.selectItem.styleConfig.commongConfig
                                  .labelConfig.textConfig.valueIsItalic,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.selectItem.styleConfig.commongConfig
                                    .labelConfig.textConfig,
                                  "valueIsItalic",
                                  $$v
                                )
                              },
                              expression:
                                "selectItem.styleConfig.commongConfig.labelConfig.textConfig.valueIsItalic",
                            },
                          }),
                        ],
                        1
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value:
                            _vm.selectItem.styleConfig.commongConfig
                              .gaugeLabelStyle === 0,
                          expression:
                            "selectItem.styleConfig.commongConfig.gaugeLabelStyle === 0",
                        },
                      ],
                      staticClass: "chart-form-item-warp",
                    },
                    [
                      _c("span", { staticClass: "jz-chart-title-label" }, [
                        _vm._v("\n            占比值小数位数\n          "),
                      ]),
                      _vm._v(" "),
                      _c(
                        "el-select",
                        {
                          attrs: {
                            size: "small",
                            placeholder: "请选择",
                            "popper-class": "c-select-style-popper",
                          },
                          model: {
                            value:
                              _vm.selectItem.styleConfig.commongConfig
                                .labelConfig.textConfig.labelDecimalPlaces,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.selectItem.styleConfig.commongConfig
                                  .labelConfig.textConfig,
                                "labelDecimalPlaces",
                                $$v
                              )
                            },
                            expression:
                              "selectItem.styleConfig.commongConfig.labelConfig.textConfig.labelDecimalPlaces",
                          },
                        },
                        _vm._l(_vm.decimalPlacesOptions, function (option) {
                          return _c("el-option", {
                            key: option.value,
                            attrs: { label: option.label, value: option.value },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "style-sub-item",
                {
                  staticClass: "c-bi-dashboard-text-style",
                  staticStyle: { "margin-top": "12px", padding: "12px" },
                  attrs: { title: "副标签" },
                },
                [
                  _c("el-form-item", [
                    _c(
                      "div",
                      { staticClass: "chart-form-item-warp" },
                      [
                        _c("span", { staticClass: "jz-chart-title-label" }, [
                          _vm._v("\n              是否开启\n            "),
                        ]),
                        _vm._v(" "),
                        _c("el-switch", {
                          attrs: { size: "small" },
                          model: {
                            value:
                              _vm.selectItem.styleConfig.commongConfig
                                .labelConfig.textConfig.isShow,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.selectItem.styleConfig.commongConfig
                                  .labelConfig.textConfig,
                                "isShow",
                                $$v
                              )
                            },
                            expression:
                              "selectItem.styleConfig.commongConfig.labelConfig.textConfig.isShow",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "chart-form-item-warp" },
                      [
                        _c("span", { staticClass: "jz-chart-title-label" }, [
                          _vm._v("\n              字体颜色\n            "),
                        ]),
                        _vm._v(" "),
                        _c("el-color-picker", {
                          attrs: { size: "small" },
                          model: {
                            value:
                              _vm.selectItem.styleConfig.commongConfig
                                .labelConfig.textConfig.color,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.selectItem.styleConfig.commongConfig
                                  .labelConfig.textConfig,
                                "color",
                                $$v
                              )
                            },
                            expression:
                              "selectItem.styleConfig.commongConfig.labelConfig.textConfig.color",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "chart-form-item-warp" },
                      [
                        _c("span", { staticClass: "jz-chart-title-label" }, [
                          _vm._v("\n              字体大小\n            "),
                        ]),
                        _vm._v(" "),
                        _c("el-input-number", {
                          attrs: {
                            min: 12,
                            max: 20,
                            step: 1,
                            "controls-position": "right",
                            size: "small",
                          },
                          model: {
                            value:
                              _vm.selectItem.styleConfig.commongConfig
                                .labelConfig.textConfig.fontSize,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.selectItem.styleConfig.commongConfig
                                  .labelConfig.textConfig,
                                "fontSize",
                                $$v
                              )
                            },
                            expression:
                              "selectItem.styleConfig.commongConfig.labelConfig.textConfig.fontSize",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "chart-form-item-warp" },
                      [
                        _c("span", { staticClass: "jz-chart-title-label" }, [
                          _vm._v("\n              加粗\n            "),
                        ]),
                        _vm._v(" "),
                        _c("el-switch", {
                          attrs: { size: "small" },
                          model: {
                            value:
                              _vm.selectItem.styleConfig.commongConfig
                                .labelConfig.textConfig.isBold,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.selectItem.styleConfig.commongConfig
                                  .labelConfig.textConfig,
                                "isBold",
                                $$v
                              )
                            },
                            expression:
                              "selectItem.styleConfig.commongConfig.labelConfig.textConfig.isBold",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "chart-form-item-warp" },
                      [
                        _c("span", { staticClass: "jz-chart-title-label" }, [
                          _vm._v("\n              斜体\n            "),
                        ]),
                        _vm._v(" "),
                        _c("el-switch", {
                          attrs: { size: "small" },
                          model: {
                            value:
                              _vm.selectItem.styleConfig.commongConfig
                                .labelConfig.textConfig.isItalic,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.selectItem.styleConfig.commongConfig
                                  .labelConfig.textConfig,
                                "isItalic",
                                $$v
                              )
                            },
                            expression:
                              "selectItem.styleConfig.commongConfig.labelConfig.textConfig.isItalic",
                          },
                        }),
                      ],
                      1
                    ),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }